import { Grid, Stack, TextField, Typography } from '@mui/material'
import { VesselVisitFormStore } from '@planning/pages/VesselVisit/Stores/VesselVisitFormStore'
import { useTranslate } from '@tolgee/react'
import { DataControlCard, DataControlCardProps, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

export type VesselVisitNotesViewProps = {
  notes?: string | null
}

const VesselVisitNotesViewMode = observer((props: Partial<VesselVisitNotesViewProps>) => {
  const { notes } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return notes ? (
    <Stack direction='column'>
      <Typography variant='body2' color={theme.palette.text.secondary}>
        {notes}
      </Typography>
    </Stack>
  ) : (
    <Typography variant='body2' color={theme.palette.text.secondary}>
      {t('noInformationYet', 'No information yet')}
    </Typography>
  )
})

const VesselVisitNotesEditMode = observer((props: { store: VesselVisitFormStore }) => {
  const { store } = props
  const { t } = useTranslate()

  return (
    <Grid container spacing={2} width={'100%'}>
      <Grid size={{ xs: 12 }}>
        <TextField
          {...store.notes.props}
          id='notes'
          fullWidth
          multiline
          minRows={5}
          maxRows={5}
          label={`${t('notes', 'Notes')}`}
          variant='outlined'
          type='text'
          name='notes'
          data-cy='vessel-visit-notes-input'
          inputProps={{ maxLength: 2000 }}
        />
      </Grid>
    </Grid>
  )
})

export const VesselVisitNotesControlCard = observer(
  (
    props: Partial<DataControlCardProps> & {
      formStore?: VesselVisitFormStore
      isEditMode: boolean
    },
  ) => {
    const { formStore, isEditMode } = props
    const { t } = useTranslate()

    return (
      <DataControlCard
        {...props}
        autoFocusId='notes'
        title={t('Notes', 'Notes')}
        dataCy='notes'
        viewComponent={<VesselVisitNotesViewMode notes={formStore?.data.notes} />}
        editComponent={formStore && <VesselVisitNotesEditMode store={formStore} />}
        // isEditMode here referes to the edit mode of the page, not the card
        defaultEditMode={!isEditMode}
      />
    )
  },
)
